/**
 * 模块: PriceCVRInsight Summary Cards
 * 职责: 价格-转化率洞察概览卡片
 * 限制: <280行
 */

import React from 'react';
import { Card, Row, Col, Statistic, Tag } from 'antd';
import type {
  PriceElasticityResult,
  OptimalPriceRangeResult,
  PriceDisadvantageResult,
} from '../../../../services/priceCVRAPI';

interface SummaryCardsProps {
  elasticityData: PriceElasticityResult;
  priceRangeData: OptimalPriceRangeResult;
  disadvantageData: PriceDisadvantageResult;
}

export const SummaryCards: React.FC<SummaryCardsProps> = ({
  elasticityData,
  priceRangeData,
  disadvantageData,
}) => {
  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
      <Col span={8}>
        <Card size="small">
          <Statistic
            title="当前ASIN价格"
            value={priceRangeData.asin_current_price}
            prefix="$"
            precision={2}
            valueStyle={{ color: '#1890ff' }}
          />
          <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
            推荐区间: <Tag color="green">{priceRangeData.recommended_range}</Tag>
          </div>
        </Card>
      </Col>
      <Col span={8}>
        <Card size="small">
          <Statistic
            title="价格敏感关键词"
            value={elasticityData.summary.high_sensitivity}
            suffix={`/ ${elasticityData.summary.total_keywords}`}
            valueStyle={{ color: '#f5222d' }}
          />
          <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
            高敏感度（降价效果显著）
          </div>
        </Card>
      </Col>
      <Col span={8}>
        <Card size="small">
          <Statistic
            title="价格劣势关键词"
            value={disadvantageData.summary.disadvantage_count}
            suffix={`/ ${disadvantageData.summary.total_keywords}`}
            valueStyle={{ color: '#faad14' }}
          />
          <div style={{ marginTop: 8, fontSize: 12, color: '#999' }}>
            需要优化定价策略
          </div>
        </Card>
      </Col>
    </Row>
  );
};

